import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = firebase.initializeApp({
  apiKey: "AIzaSyAQn7ivm1bQAijUiU2_djRmTlUytX1HCGU",
  authDomain: "e-commerce-a0cef.firebaseapp.com",
  projectId: "e-commerce-a0cef",
  storageBucket: "e-commerce-a0cef.appspot.com",
  messagingSenderId: "1088547497051",
  appId: "1:1088547497051:web:a9cc7d9b190944d4b40b7e",
  measurementId: "G-JDJ3VGPV2Z"
});

export default firebaseConfig;